import { ValueOfKey } from '../../utils-types';

export const CHALLENGE_PROFILE_TAB = {
  GENERAL: 'GENERAL',
  PARTICIPANTS: 'PARTICIPANTS',
  PROMO_CODES: 'PROMO_CODES',
  SETTINGS: 'SETTINGS',
} as const;

export type ChallengeProfileTab = ValueOfKey<typeof CHALLENGE_PROFILE_TAB>;
